var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas fa-trash pointer text-danger",attrs:{"b-v-tooltip.hover":"","title":_vm.$lang.Common.Tooltip.ButtonDelete},on:{"click":_vm.onClick}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ef8d91","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/coptype/actionsCellRenderer.vue
// module id = null
// module chunks = 